<app-page-content class="independent-scroll-page">
<app-doenkids-menu-bar menuBar [showBackButton]="true" [backUrl]="backUrl" [loading]="pageLoading$ | async">
  <div class="flex-1 flex-row items-center justify-start" left>
    <!-- Actions Menu for mobile/smaller screens -->
    <mat-menu #actionsMenu="matMenu" class="vertical-actions-menu">
      @if (!(isReader$ | async)) {
        <button
          [disabled]="!(hasWriteAccess$ | async) || !(isTheOwner$ | async)"
          mat-menu-item
          type="button"
          (click)="addPeriod()"
          >
          <mat-icon>add</mat-icon>
          <span>{{ 'program_details.field.add' | translate }}</span>
        </button>
      }
      @if (!(isReader$ | async)) {
        <button
          [disabled]="!(hasWriteAccess$ | async) || (savingProgramPleaseWait$ | async) || !(isTheOwner$ | async) || !programForm.valid"
          mat-menu-item
          type="button"
          (click)="saveDetails()"
          >
          <mat-icon>save</mat-icon>
          <span>{{ 'program.save' | translate }}</span>
        </button>
      }
      @if (!(isReader$ | async) && showProgramTemplateCreate$ | async) {
        <button
          [disabled]="!(hasWriteAccess$ | async) || !(isTheOwner$ | async)"
          mat-menu-item
          type="button"
          (click)="createProgramTemplate()"
          >
          <mat-icon>file_copy</mat-icon>
          <span>{{ 'program_details.template.create' | translate }}</span>
        </button>
      }
      <button mat-menu-item type="button" (click)="downloadPDF()">
        <mat-icon>get_app</mat-icon>
        <span>{{ 'program_details.pdf.download' | translate }}</span>
      </button>
      @if (!(isReader$ | async)) {
        <button mat-menu-item type="button" (click)="copyProgramToOtherLocation()">
          <mat-icon>call_split</mat-icon>
          <span>{{ 'program_details.copy' | translate }}</span>
        </button>
      }
      @if (!(isReader$ | async) && (thereAreCustomerSymbolsToUse$ | async)) {
        <button
          type="button"
          mat-menu-item
          (click)="selectSymbols()"
          [disabled]="!(isTheOwner$ | async)"
          >
          <mat-icon>radio_button_checked</mat-icon>
          <span>{{ 'program_details.symbols.edit' | translate }}</span>
        </button>
      }
      @if ((programPeriods$ | async); as periods) {
        @if (!(isReader$ | async) && periodForm.value[periods[0]?.id]?.period_type === 'FREEFORM') {
          <button
            [disabled]="!(hasWriteAccess$ | async) || !(isTheOwner$ | async)"
            type="button"
            mat-menu-item
            (click)="convertProgramToDayProgram(periods)"
            >
            <mat-icon>event_available</mat-icon>
            <span>{{ 'program_details.covert.to_day_program' | translate }}</span>
          </button>
        }
        @if (!(isReader$ | async) && periodForm.value[periods[0]?.id]?.period_type === 'DATE') {
          <button
            [disabled]="!(hasWriteAccess$ | async) || !(isTheOwner$ | async)"
            type="button"
            mat-menu-item
            (click)="convertProgramToFreeForm(periods)"
            >
            <mat-icon>event_busy</mat-icon>
            <span>{{ 'program_details.convert.to_freeform' | translate }}</span>
          </button>
        }
      }
    </mat-menu>

    <!-- Actions menu trigger button for smaller screens -->
    <button
      mat-icon-button
      type="button"
      [matMenuTriggerFor]="actionsMenu"
      [matTooltip]="'program_details.actions' | translate"
      class="actions-menu-button"
      >
      <mat-icon>more_vert</mat-icon>
    </button>

    <!-- Individual action buttons for larger screens -->
    <div class="individual-actions">
      @if (!(isReader$ | async)) {
        <button
          [disabled]="!(hasWriteAccess$ | async) || !(isTheOwner$ | async)"
          mat-icon-button
          type="button"
          (click)="addPeriod()"
          [matTooltip]="'program_details.field.add' | translate"
          >
          <mat-icon>add</mat-icon>
        </button>
      }
      @if (!(isReader$ | async)) {
        <button
          [disabled]="!(hasWriteAccess$ | async) || (savingProgramPleaseWait$ | async) || !(isTheOwner$ | async) || !programForm.valid"
          mat-icon-button
          type="button"
          (click)="saveDetails()"
          [matTooltip]="'program.save' | translate"
          >
          <mat-icon>save</mat-icon>
        </button>
      }
      @if (!(isReader$ | async) && showProgramTemplateCreate$ | async) {
        <button
          [disabled]="!(hasWriteAccess$ | async) || !(isTheOwner$ | async)"
          mat-icon-button
          type="button"
          (click)="createProgramTemplate()"
          [matTooltip]="'program_details.template.create' | translate"
          >
          <mat-icon>file_copy</mat-icon>
        </button>
      }
      <button
        mat-icon-button
        type="button"
        (click)="downloadPDF()"
        [matTooltip]="'program_details.pdf.download' | translate"
        >
        <mat-icon>get_app</mat-icon>
      </button>
      @if (!(isReader$ | async)) {
        <button
          mat-icon-button
          type="button"
          (click)="copyProgramToOtherLocation()"
          [matTooltip]="'program_details.copy' | translate"
          >
          <mat-icon>call_split</mat-icon>
        </button>
      }
      @if (!(isReader$ | async) && (thereAreCustomerSymbolsToUse$ | async)) {
        <button
          type="button"
          mat-icon-button
          (click)="selectSymbols()"
          [disabled]="!(isTheOwner$ | async)"
          [matTooltip]="'program_details.symbols.edit' | translate"
          >
          <mat-icon>radio_button_checked</mat-icon>
        </button>
      }
      @if ((programPeriods$ | async); as periods) {
        @if (!(isReader$ | async) && periodForm.value[periods[0]?.id]?.period_type === 'FREEFORM') {
          <button
            [disabled]="!(hasWriteAccess$ | async) || !(isTheOwner$ | async)"
            type="button"
            mat-icon-button
            (click)="convertProgramToDayProgram(periods)"
            [matTooltip]="'program_details.covert.to_day_program' | translate"
            >
            <mat-icon>event_available</mat-icon>
          </button>
        }
        @if (!(isReader$ | async) && periodForm.value[periods[0]?.id]?.period_type === 'DATE') {
          <button
            [disabled]="!(hasWriteAccess$ | async) || !(isTheOwner$ | async)"
            type="button"
            mat-icon-button
            (click)="convertProgramToFreeForm(periods)"
            [matTooltip]="'program_details.convert.to_freeform' | translate"
            >
            <mat-icon>event_busy</mat-icon>
          </button>
        }
      }
    </div>
    @if (!(showMobileLayout$ | async)) {
      @if ((program$ | async)?.data; as program) {
        <div class="flex-row items-center justify-start">
          @if ((!(hasWriteAccess$ | async) || (isAdmin$ | async)) && (isTheOwner$ | async)) {
            <mat-chip-listbox hideSingleSelectionIndicator>
              @if (programOwner$ | async) {
                <mat-chip-option class="status-chip customer-chip">
                  {{ (programOwner$ | async)?.name }}
                </mat-chip-option>
              } @else {
                <mat-chip-option class="status-chip customer-chip unpublished">{{ 'program_details.no_owner' | translate }}</mat-chip-option>
              }
            </mat-chip-listbox>
          }
          @if (programOwner$ | async; as owner) {
            <app-owner-chip
              (isTheOwnerChange)="handleIsTheOwnerChange($event)"
              [owningOuId]="owner.organization_unit_id"
            ></app-owner-chip>
          }
          <ng-container *ngVar="(possibleContentLanguages$ | async) as contentLanguages">
            @if ((hasWriteAccess$ | async) && contentLanguages.length > 1) {
              <mat-form-field
                appearance="outline"
                class="compact-select content-language-select"
                >
                <mat-label>{{ 'program.content_language.label' | translate }}</mat-label>
                <mat-select [formControl]="contentLanguageControl">
                  @if (contentLanguageControl.value) {
                    <mat-select-trigger>
                      <mat-icon [svgIcon]="contentLanguageControl.value.toLowerCase()"></mat-icon>
                      {{ 'generic.language.' + contentLanguageControl.value.toLowerCase()| translate }}
                    </mat-select-trigger>
                  }
                  @for (contentLanguage of contentLanguages; track contentLanguage) {
                    <mat-option
                      [value]="contentLanguage"
                      >
                      <mat-icon [svgIcon]="contentLanguageControl.value.toLowerCase()"></mat-icon>
                      {{ 'generic.language.' + contentLanguage.toLowerCase() | translate }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
          </ng-container>
          <!-- Current Status Chip -->
          @if (program.program_status_id; as statusId) {
            <app-status-chip
              [statusName]="getProgramStatusName(statusId)"
              [translationKey]="'program.status.' + getProgramStatusName(statusId)"
            ></app-status-chip>
            @if ((hasWriteAccess$ | async); as writeAccess) {
              <app-publish-button
                [currentStatusName]="getProgramStatusName(statusId)"
                [hasWriteAccess]="writeAccess"
                [statusOptions]="getProgramStatusOptionsForMenu(statusId)"
                [publishTooltip]="writeAccess ? (getProgramStatusName(statusId) === 'published' ? ('program_details.status.already_published' | translate) : ('program_details.status.publish' | translate)) : undefined"
                [optionsTooltip]="writeAccess ? ('program_details.status.options' | translate) : undefined"
                menuId="programStatusOptionsMenu"
                (publish)="publishProgram()"
                (statusSelected)="changePublicationStatus($event)"
              ></app-publish-button>
            }
          }
        </div>
      }
    }
  </div>
  <div right>
    @if (hasWriteAccess$ | async) {
      <button mat-icon-button type="button" (click)="goToEventLogs()" [matTooltip]="'program_details.event_log.view' | translate">
        <mat-icon>assignment</mat-icon>
      </button>
    }
    @if (!(isReader$ | async) && (isTheOwner$ | async)) {
      <button mat-icon-button type="button" (click)="removeProgram()" [matTooltip]="'program.delete' | translate">
        <mat-icon>delete</mat-icon>
      </button>
    }
  </div>
</app-doenkids-menu-bar>
<div content>

@if (hasNoAccess$ | async) {
  <div class="no-access-container">
    <mat-icon>lock</mat-icon>
    <p class="no-access-title">{{ 'program_details.no_access.title' | translate }}</p>
    <p class="no-access-description">{{ 'program_details.no_access.description' | translate }}</p>
  </div>
} @else {

<app-split-page
  [leftLabel]="'generic.details' | translate"
  [rightLabel]="(selectedPeriodId$ | async) ? ('program_details.tab.activities' | translate) : ('program_details.tab.template' | translate)"
  [activeTab]="activeTab"
  [independentScroll]="true"
  (selectedTabChange)="openTab($event.index)"
  >
  <ng-template #left>
    <div class="details-container">
      @if (showMobileLayout$ | async) {
        @if ((program$ | async)?.data; as program) {
          <div class="mobile-chips-section">
            <div class="flex-row items-center justify-start flex-wrap gap-2">
              @if ((!(hasWriteAccess$ | async) || (isAdmin$ | async)) && (isTheOwner$ | async)) {
                <mat-chip-listbox hideSingleSelectionIndicator>
                  @if (programOwner$ | async) {
                    <mat-chip-option class="status-chip customer-chip">
                      {{ (programOwner$ | async)?.name }}
                    </mat-chip-option>
                  } @else {
                    <mat-chip-option class="status-chip customer-chip unpublished">{{ 'program_details.no_owner' | translate }}</mat-chip-option>
                  }
                </mat-chip-listbox>
              }
              @if (programOwner$ | async; as owner) {
                <app-owner-chip
                  (isTheOwnerChange)="handleIsTheOwnerChange($event)"
                  [owningOuId]="owner.organization_unit_id"
                ></app-owner-chip>
              }
              <ng-container *ngVar="(possibleContentLanguages$ | async) as contentLanguages">
                @if ((hasWriteAccess$ | async) && contentLanguages.length > 1) {
                  <mat-form-field
                    appearance="outline"
                    class="compact-select content-language-select"
                    >
                    <mat-label>{{ 'program.content_language.label' | translate }}</mat-label>
                    <mat-select [formControl]="contentLanguageControl">
                      @if (contentLanguageControl.value) {
                        <mat-select-trigger>
                          <mat-icon [svgIcon]="contentLanguageControl.value.toLowerCase()"></mat-icon>
                          {{ 'generic.language.' + contentLanguageControl.value.toLowerCase()| translate }}
                        </mat-select-trigger>
                      }
                      @for (contentLanguage of contentLanguages; track contentLanguage) {
                        <mat-option
                          [value]="contentLanguage"
                          >
                          <mat-icon [svgIcon]="contentLanguage.toLowerCase()"></mat-icon>
                          {{ 'generic.language.' + contentLanguage.toLowerCase() | translate }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
              </ng-container>
              @if (program.program_status_id; as statusId) {
                <app-status-chip
                  [statusName]="getProgramStatusName(statusId)"
                  [translationKey]="'program.status.' + getProgramStatusName(statusId)"
                ></app-status-chip>
                @if ((hasWriteAccess$ | async); as writeAccess) {
                  <app-publish-button
                    [currentStatusName]="getProgramStatusName(statusId)"
                    [hasWriteAccess]="writeAccess"
                    [statusOptions]="getProgramStatusOptionsForMenu(statusId)"
                    [publishTooltip]="writeAccess ? (getProgramStatusName(statusId) === 'published' ? ('program_details.status.already_published' | translate) : ('program_details.status.publish' | translate)) : undefined"
                    [optionsTooltip]="writeAccess ? ('program_details.status.options' | translate) : undefined"
                    menuId="programStatusOptionsMenuMobile"
                    (publish)="publishProgram()"
                    (statusSelected)="changePublicationStatus($event)"
                  ></app-publish-button>
                }
              }
            </div>
          </div>
        }
      }
      <mat-accordion>
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ 'program_details.title' | translate }}</mat-panel-title>
            <mat-panel-description>{{ 'program_details.description' | translate }}</mat-panel-description>
          </mat-expansion-panel-header>

          <form [formGroup]="programForm">
            <div class="flex-row">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'program.title.label' | translate }}</mat-label>
                <input type="text" matInput formControlName="name" [errorStateMatcher]="errorStateMatcher" />
                @if (programForm.get('name').hasError('required')) {
                  <mat-error>
                    {{ 'generic.form.required_field' | translate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="program-content flex-col">
              <mat-label>{{ 'program.content.label' | translate }}</mat-label>
              <quill-editor bounds="self" theme="bubble" formControlName="content" [placeholder]="'program.content.placeholder' | translate"></quill-editor>
            </div>
            <div class="program-dates flex-row">
              <mat-form-field>
                <mat-label>{{ 'generic.period.start_date' | translate }}</mat-label>
                <input matInput [matDatepicker]="startDate" [max]="getDatepickerMaxDate(programForm.get('to')?.value)" formControlName="from" readonly />
                <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
                <mat-datepicker #startDate></mat-datepicker>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'generic.period.end_date' | translate }}</mat-label>
                <input matInput [matDatepicker]="endDate" [min]="getDatepickerMinDate(programForm.get('from')?.value)" formControlName="to" readonly />
                <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
                <mat-datepicker #endDate></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="select-field">
              <mat-form-field color="primary" class="customer-field">
                <mat-label>{{ 'program.location.placeholder ' | translate }}</mat-label>
                <mat-select formControlName="customer_location_id">
                  @for (location of availableLocations$ | async; track location.id) {
                    <mat-option [value]="location.id">
                      {{ location.name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <div class="select-field group-selection">
              <mat-label>{{ 'program.groups.label' | translate }}</mat-label>
              @if ((availableGroups$ | async)?.length >= 1) {
                <mat-selection-list class="program-groups" formControlName="customer_groups" role="listbox">
                  @for (availableGroup of availableGroups$ | async; track availableGroup.id) {
                    <mat-list-option [value]="availableGroup.id">
                      <span class="option-label">{{ availableGroup.name }}</span>
                    </mat-list-option>
                  }
                </mat-selection-list>
              }
              @if ((availableGroups$ | async)?.length === 0) {
                <div class="error-text">
                  {{ 'program.groups.none_available' | translate }}
                </div>
              }
            </div>
          </form>
        </mat-expansion-panel>
        @if (!(templateImagesDisabled$ | async) && (templateImagesCount$ | async) > 0) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>{{ 'program.template_images.title' | translate }}</mat-panel-title>
              <mat-panel-description>
                {{
                'program.template_images.description'
                | translate
                : {
                imageCount: (templateImagesCount$ | async)
              }
              }}
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="panel-body">
            @for (_ of [].constructor((templateImagesCount$ | async)); track index; let index = $index) {
              <div class="template-image-container">
                @if ('templateImage' + index; as identifier) {
                  <app-asset-upload
                    [identifier]="identifier"
                    purpose="template"
                    (uploaded)="addTemplateImage($event, index)"

                    >
                    <ng-template let-uploadData="uploadData">
                      <div class="image-container">
                        @if ((templateImages$ | async); as templateImages) {
                          <app-doenkids-image
                            class="square"
                            [maxWidth]="200"
                            [maxHeight]="200"
                            [preview]="true"
                            [mediaItem]="templateImagesForm.get(index.toString())?.value"
                            [canReplaceImage]="(index !== 0 || index === 0 && !(templateImagesFirstFixed$ | async)) && isAdmin$ | async"
                            >
                            @if ((index !== 0 || index === 0 && !(templateImagesFirstFixed$ | async)) && !(isReadOnly$ | async)) {
                              <app-select-media
                                [mediaItemUuid]="templateImagesForm.get(index.toString())?.value"
                                [identifier]="identifier"
                                [uploadData]="uploadData"
                                [removable]="templateImagesForm.get(index.toString())?.value"
                                (selected)="addTemplateImage($event, index)"
                                purpose="template"
                                [programId]="programId"
                                >
                              </app-select-media>
                            }
                          </app-doenkids-image>
                        }
                      </div>
                    </ng-template>
                  </app-asset-upload>
                }
              </div>
            }
            @if (!(isReadOnly$ | async)) {
              <button
                [disabled]="!(hasWriteAccess$ | async)"
                mat-button
                class="flex-fill"
                color="primary"
                type="button"
                (click)="saveTemplateSettings()"
                >
                {{ 'generic.save' | translate }}
              </button>
            }
          </div>
        </mat-expansion-panel>
      }
      @if ((hasProgramExplanationPermission$ | async) && (programExplanations$ | async)?.length > 0) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>{{ 'program.explanation.title' | translate }}</mat-panel-title>
            <mat-panel-description>
              {{ 'program.explanation.description' | translate: { explanationCount: (programExplanations$ | async).length } }}
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="panel-body">
            @for (explanation of programExplanations$ | async; track explanation; let index = $index) {
              <div class="download-buttons">
                <button mat-flat-button color="primary" type="button" (click)="downloadAttachment(explanation)">
                  {{
                  'program_details.attachment.download'
                  | translate
                  : {
                  name: explanation.display_name ? explanation.display_name : explanation.filename
                }
                }}
              </button>
            </div>
          }
        </div>
      </mat-expansion-panel>
    }

    @if ((programAttachments$ | async)?.length > 0) {
      <mat-expansion-panel>
        <mat-expansion-panel-header *ngVar="(programAttachments$ | async)?.length as count">
          <mat-panel-title>{{ 'generic.attachments' | translate }}</mat-panel-title>
          <mat-panel-description>{{ 'program_details.attachment.count' | translate: { count } }}</mat-panel-description>
        </mat-expansion-panel-header>
        <div class="panel-body">
          @for (attachment of programAttachments$ | async; track attachment; let index = $index) {
            <div class="download-buttons">
              <button mat-flat-button color="primary" type="button" (click)="downloadAttachment(attachment)">
                {{ 'program_details.attachment.download' | translate: { name: (attachment.display_name ?? attachment.filename) } }}
              </button>
            </div>
          }
        </div>
      </mat-expansion-panel>
    }
  </mat-accordion>
  <form [formGroup]="periodForm">
    @if ((programPeriods$ | async); as periods) {
      <app-panel-container
        cdkDropList
        [cdkDropListData]="periods"
        (cdkDropListDropped)="dropPeriod($event)"
        appExpansionPanelController
        >
        <ng-template let-periodIndex="index">
          @if (periods[periodIndex]; as period) {
            <div
              class="activity-wrapper"
              cdkDrag
              [class.hasActivities]="periodHasActivities(period) && periodIsSelected(period)"
              >
              @if (periodForm.get(period?.id?.toString()); as singlePeriodForm) {
                <mat-expansion-panel
                  class="period-panel"
                  [class.selected]="(selectedPeriodId$ | async) === period.id"
                  [class.hasActivities]="periodHasActivities(period) && periodIsSelected(period)"
                  [expanded]="(selectedPeriodId$ | async) === period.id"
                  (afterCollapse)="detectAllCollapsed()"
                  (afterExpand)="openPanel(period.id)"
                  >
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <app-drag-handle cdkDragHandle></app-drag-handle>
                      <span>
                        {{
                        singlePeriodForm.get('period_type')?.value === 'FREEFORM'
                        ? singlePeriodForm.get('name')?.value || ('generic.field' | translate)
                        : (singlePeriodForm.get('start_date')?.value | i18n_date: 'fullDate' | async | titlecase)
                        }}
                      </span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ng-template matExpansionPanelContent>
                    <app-program-period [period]="$any(singlePeriodForm)" [program]="programForm">
                      @if (periodHasActivities(period)) {
                        <div class="period-activities">
                          <fieldset>
                            <legend>{{ 'program.activities.label' | translate }}</legend>
                            <mat-list>
                              @for (activity of getPeriodSectionActivities(period); track activity.id; let isLast = $last) {
                                @if (activity) {
                                  <mat-list-item (click)="openPeriodSectionActivity(period.id, activity.id)" class="period-section-activity">
                                    <mat-icon matListItemIcon>visibility</mat-icon>
                                    <div matListItemTitle>{{ activity?.title ? activity?.title : ('generic.activity' | translate) }}</div>
                                  </mat-list-item>
                                  @if (!isLast) {
                                    <mat-divider></mat-divider>
                                  }
                                }
                              }
                            </mat-list>
                          </fieldset>
                        </div>
                      }
                      <div class="period-button-section flex-row justify-between items-center">
                        <button (click)="removePeriod(period)" mat-button type="button">
                          {{ 'generic.delete' | translate }}
                        </button>
                        <button mat-button type="button" class="icon-button" (click)="switchBetweenPDFandPeriodSections(); openTab(1)">
                          {{
                          (rightSideView$ | async) === 'periodSections' ? ('program_details.template' | translate) : ('program_details.overview' | translate)
                          }}
                          @if ((rightSideView$ | async) !== 'periodSections') {
                            <mat-icon>edit</mat-icon>
                          }
                          @if ((rightSideView$ | async) === 'periodSections') {
                            <mat-icon>visibility</mat-icon>
                          }
                        </button>
                        <button (click)="savePeriod(period)" mat-button type="button">
                          {{ 'generic.save' | translate }}
                        </button>
                      </div>
                    </app-program-period>
                  </ng-template>
                </mat-expansion-panel>
              }
              @if (periodHasActivities(period) && periodIsSelected(period)) {
                <div class="period-activities">
                  <fieldset>
                    <legend>{{ 'program.activities.label' | translate }}</legend>
                    <mat-list>
                      @for (activity of getPeriodSectionActivities(period); track activity.id; let isLast = $last) {
                        @if (activity) {
                          <mat-list-item (click)="openPeriodSectionActivity(period.id, activity.id)" class="period-section-activity">
                            <mat-icon matListItemIcon>visibility</mat-icon>
                            <div matListItemTitle>{{ activity?.title ? activity.title : ('generic.activity' | translate) }}</div>
                          </mat-list-item>
                          @if (!isLast) {
                            <mat-divider></mat-divider>
                          }
                        }
                      }
                    </mat-list>
                  </fieldset>
                </div>
              }
            </div>
          }
        </ng-template>
      </app-panel-container>
    }
  </form>
</div>
</ng-template>
<ng-template #right>
  @if ((rightSideView$ | async) === 'pdf') {
    <div class="pdf-container">
      <app-pdf-viewer
        [pdfSrc]="pdf$ | async"
        [loading]="pdfLoading$ | async"
        (pdfLoaded)="onPdfLoadedEvent()"
      ></app-pdf-viewer>
    </div>
  }
  @if ((rightSideView$ | async) === 'periodSections') {
    <app-program-period-sections
      #programSections
      [readOnly]="(isReadOnly$ | async)"
      [periodId$]="selectedPeriodId$"
      [periods$]="programPeriods$"
      [programId]="programId"
      [programLanguage]="(program$ | async)?.data?.language"
      (close)="setPanelToPdf()"
      (periodSectionsChanged)="updatePeriodActivities()"
      [excludedActivityIds$]="excludedActivityIds$"
      >
    </app-program-period-sections>
  }
</ng-template>
</app-split-page>

} <!-- end @else (hasNoAccess) -->

</div>
</app-page-content>
